import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-project-env-editor',
  templateUrl: './project-env-editor.component.html',
  styleUrls: ['./project-env-editor.component.css']
})
export class ProjectEnvEditorComponent implements OnInit, OnChanges {

  @Input() envJson: string = "";
  @Output() envJsonChange = new EventEmitter<string>();

  env: any = {
    admin: { email: '', password: '', roles: '' },
    mail: {
      redirectUri: '',
      host: '',
      port: 465,
      username: '',
      password: '',
      protocol: 'smtp',
      sslTrust: 'smtp.hostinger.com',
      auth: true,
      sslEnable: true,
      starttlsEnable: true,
      connectionTimeout: 5000,
      timeout: 5000,
      writeTimeout: 5000
    },
    otp: { expiration: 900000, length: 6 },
    callbacks: {
      userCreated: ''
    }
  };

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['envJson'] && this.envJson) {
      try {
        const parsed = JSON.parse(this.envJson);

        // Merge but do NOT lose defaults
        this.env = {
          ...this.env,
          ...parsed,
          admin: { ...this.env.admin, ...(parsed.admin || {}) },
          mail: { ...this.env.mail, ...(parsed.mail || {}) },
          otp: { ...this.env.otp, ...(parsed.otp || {}) }
        };

      } catch (e) {
        console.warn("Invalid JSON received");
      }
    }
  }

  updateJson() {
    const cleaned = this.cleanObject(this.env);
    this.envJson = JSON.stringify(cleaned, null, 2);
    this.envJsonChange.emit(this.envJson);
  }

  cleanObject(obj: any): any {
    const cleaned: any = {};
    Object.keys(obj).forEach(key => {
      const value = obj[key];
      if (value === "" || value === null || value === undefined) return;

      if (typeof value === "object" && !Array.isArray(value)) {
        const nested = this.cleanObject(value);
        if (Object.keys(nested).length > 0) cleaned[key] = nested;
      } else {
        cleaned[key] = value;
      }
    });
    return cleaned;
  }
}
